import { Button, Box, Modal, Text, Divider } from '@stitch-fix/mode-react';
import React, { useState } from 'react';
import { CloudinaryImageWrapper, type CloudinaryImageFields } from '../../CloudinaryImageWrapper';
import styles from './styles.module.scss';
export interface PersonProps {
  name: string;
  title: string;
  role: string;
  description: string;
  image: CloudinaryImageFields;
}
export const Person = ({
  name,
  title,
  role,
  description,
  image
}: PersonProps) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return <Box className={styles.personContainer}>
      <Box className={styles.personHeadshot}>
        <CloudinaryImageWrapper src={image.src} alt={image.alt} sources={{
        sm: 220
      }} aspectRatio={image.aspectRatio} cloudinaryAsset={image.cloudinaryAsset} sizes={[{
        minWidth: 0,
        staticWidth: 220
      }]} maxContainerWidth={60 * 16} imageProps={{
        loading: 'lazy'
      }} />
      </Box>
      <Text setting="title-xsmall" spacingBottom>
        {name}
      </Text>
      <Text setting="body-small">{title}</Text>
      <Box className={styles.personUnderline}>
        <Divider variant="item" my={1} />
      </Box>
      <Text setting="body-medium" mb={1}>
        {role}
      </Text>
      <Button variant="text" onClick={() => setModalOpen(true)}>
        Read more
      </Button>
      <Modal bodyLock="never" isOpen={isModalOpen} size="large" ariaLabel={`Details about ${name}`} onClose={() => {
      setModalOpen(false);
    }}>
        <Text setting="title-xsmall" align="center" spacingBottom>
          {name}
        </Text>
        <Text setting="body-small" align="center">
          {title}
        </Text>
        <Box className={styles.personUnderline}>
          <Divider variant="item" my={1} />
        </Box>
        <Text setting="body-medium">{description}</Text>
      </Modal>
    </Box>;
};